import { render, staticRenderFns } from "./EventFormSessionList.vue?vue&type=template&id=20b6a686"
import script from "./EventFormSessionList.vue?vue&type=script&lang=js"
export * from "./EventFormSessionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports